import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('archivewall', () => ({
    media: null,

    init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const archiveWall = this.$root;
        const items = gsap.utils.toArray(archiveWall.querySelectorAll('[data-archive-wall-item]'));

        if (!items.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.media = gsap.matchMedia();
        this.media.add('(min-width: 768px)', () => {
            const timelines = items.map((item, index) => {
                const depth = Number(item.dataset.depth || 1);
                const distance = 28 + depth * 16;

                return gsap.fromTo(
                    item,
                    {
                        y: index % 2 === 0 ? distance : distance * -1,
                        rotateZ: index % 3 === 0 ? -1.4 : 1.4,
                    },
                    {
                        y: index % 2 === 0 ? distance * -1 : distance,
                        rotateZ: 0,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: archiveWall,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                    }
                );
            });

            return () => {
                timelines.forEach((timeline) => timeline.kill());
                gsap.set(items, { clearProps: 'transform,opacity' });
            };
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    },

    destroy() {
        this.media?.revert();
    },
}));
